import { render, staticRenderFns } from "./editTableMobile.vue?vue&type=template&id=37451da8&scoped=true"
import script from "./editTableMobile.vue?vue&type=script&lang=js"
export * from "./editTableMobile.vue?vue&type=script&lang=js"
import style0 from "./editTableMobile.vue?vue&type=style&index=0&id=37451da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37451da8",
  null
  
)

export default component.exports